import { Reveal } from "./Reveal";

export const Chapter = ({ n, kicker, title, dark = false }) => (
  <Reveal className="mb-14 md:mb-20 max-w-3xl">
    <p
      className={`text-xs md:text-sm tracking-[0.25em] uppercase font-semibold ${
        dark ? "text-paper/50" : "text-ink/45"
      }`}
      data-testid={`chapter-${n}-number`}
    >
      Chapter {String(n).padStart(2, "0")}
      {kicker ? ` — ${kicker}` : ""}
    </p>
    <h2
      className={`mt-5 font-serif text-3xl md:text-5xl tracking-tight leading-[1.1] ${
        dark ? "text-paper" : "text-ink"
      }`}
    >
      {title}
    </h2>
  </Reveal>
);
